import { ExceptionResolution } from '@usf/ngrx-order';
import { SellerPriceDetails } from '@usf/price-types';

export class OrderExceptionsHelper {
  static updateExceptionWithAscCharge = (
    exception: ExceptionResolution,
    sellerPrices: SellerPriceDetails[],
  ): ExceptionResolution => {
    const updatedException = JSON.parse(JSON.stringify(exception));
    const price = sellerPrices.find(
      price => price.productNumber === exception.orderItem?.productNumber,
    );

    // the price should only be updated on first load, so if the exception has a resolution type it means it has been updated and we should not update it again
    if (!!price && !exception.resolutionType) {
      updatedException.orderException.errorMessage =
        OrderExceptionsHelper.addAscCharges(
          updatedException.orderException.errorMessage,
          price,
        );
    }
    return updatedException;
  };

  static addAscCharges = (message: string, pricingDetails) => {
    if (pricingDetails.customerAscInd !== 'P') {
      return message;
    }
    const ascCharge =
      pricingDetails?.currentPrice?.autoShippingCharges?.unitAscRate || 0;
    const values = message.match(/\$[0-9]+(.[0-9]+)?/g) || [];
    values.forEach(val => {
      const newPrice: number = parseFloat(val?.slice(1)) + ascCharge;
      message = message.replace(val, `$${newPrice.toFixed(2)}`);
    });
    return message;
  };
}
